import { render, staticRenderFns } from "./UserRemoteAlarmData.vue?vue&type=template&id=08bc0d11&scoped=true"
import script from "./UserRemoteAlarmData.vue?vue&type=script&lang=js"
export * from "./UserRemoteAlarmData.vue?vue&type=script&lang=js"
import style0 from "./UserRemoteAlarmData.vue?vue&type=style&index=0&id=08bc0d11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc0d11",
  null
  
)

export default component.exports